import { State } from "../types";

export type SetMousePositionAction = Readonly<{
  position: [number, number];
  type: "SET MOUSE POSITION";
}>;

export const setMousePosition = (state: State, action: SetMousePositionAction): State => {
  let dragOffset = state.dragOffset;
  if (state.mouseDragStart) {
    dragOffset = {
      ...state.dragOffset,
      x: action.position[0] - state.mouseDragStart[0],
      y: action.position[1] - state.mouseDragStart[1],
    };
  }
  return {
    ...state,
    dragOffset,
    mousePosition: action.position,
    withinGutter: null,
  };
};
